import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCurrentCanvaMe } from "../api/CanvaApi";
import { ProfileSkeleton, ProfileDisplay, ConnectedStatus } from "./components";

const CanvaSetting = ({ appInfo }) => {
  const { t } = useTranslation();

  const [connectedUser, setConnectedUser] = useState({
    picture: "",
    name: t("Anonymous"),
    description: "",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (appInfo.connected) {
      loadProfile();
    }
  }, [appInfo]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadProfile = () => {
    setLoading(true);
    getCurrentCanvaMe()
      .then((data) => {
        setConnectedUser({
          picture: "",
          name: data?.profile?.display_name || t("Anonymous"),
          description: "",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div className="grid grid-cols-12 gap-4 mb-4">
        <div className="col-span-12 lg:col-span-3">
          <div className={"w-40"}>{t("Canva Profile")}</div>
        </div>
        <div className="col-span-12 lg:col-span-7">
          {appInfo.connected ? (
            loading ? (
              <ProfileSkeleton />
            ) : (
              <ProfileDisplay picture={connectedUser.picture} name={connectedUser.name} />
            )
          ) : (
            <div className="text-sm text-gray-500 py-2">
              {t("You need to connect your account first")}
            </div>
          )}
        </div>
        <div className="col-span-12 lg:col-span-2">{appInfo.connected && <ConnectedStatus />}</div>
      </div>
    </>
  );
};

export default CanvaSetting;
